import { Icon } from "@cobasi/ds-icons";
import Link from "next/link";

import type { IndexedSectionProps } from "./indexedSection.types";

import s from "./indexedSection.module.scss";

const IndexedSection = <T,>({
  icon,
  letter,
  items,
  getNameItem,
  getLinkItem
}: IndexedSectionProps<T>) => {
  return (
    <section className={s.section}>
      <div className={s.avatar}>
        <Icon icon={icon} width="2.4rem" height="2.4rem" />
      </div>
      <ul className={s.list}>
        {items.map((item) => (
          <li key={getNameItem(item)}>
            <Link href={getLinkItem(item)} id={`letter-${letter}`}>
              {getNameItem(item)}
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
};
export default IndexedSection;
